var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2475_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96737 5.62987H3.71737V12.6299H1.96737C1.6452 12.6299 1.38403 12.3687 1.38403 12.0465V6.2132C1.38403 5.89103 1.6452 5.62987 1.96737 5.62987ZM5.05489 4.87568L8.78852 1.14207C8.89112 1.03943 9.05364 1.02789 9.16972 1.11498L9.66707 1.48798C9.94982 1.70004 10.0772 2.06136 9.99001 2.40385L9.31725 5.04653H13.0507C13.695 5.04653 14.2174 5.56887 14.2174 6.2132V7.44072C14.2174 7.59315 14.1875 7.74406 14.1295 7.88493L12.3244 12.2686C12.2344 12.4872 12.0214 12.6299 11.785 12.6299H5.46737C5.1452 12.6299 4.88403 12.3687 4.88403 12.0465V5.28816C4.88403 5.13345 4.94549 4.98508 5.05489 4.87568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2475_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.800049 0.379883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeThumb);
export default __webpack_public_path__ + "static/media/like_thumb.7d25171768d79c5c1e895be634af33c6.svg";
export { ForwardRef as ReactComponent };